<neo-form-field [class.not-label]="!label()" [class.hide-messages]="hideMessages()">
  <neo-label>{{ label() }}</neo-label>
  <input
    neoInput
    class="date-field"
    [neoDatepicker]="datePicker"
    [required]="required()"
    [errorStateMatcher]="errorStateMatcher"
    [ngModel]="value"
    (ngModelChange)="onDateChange($event)"
    (blur)="onBlur()"
    [placeholder]="placeholder()"
    [disabled]="disabled"
    [attr.aut-id]="autId()"
  />
  <neo-datepicker-toggle neoSuffix [for]="datePicker" [autId]="autId() + '-toggle'">
    <cm-icon class="calendar-icon" name="calendar_today" mode="fill" neoDatepickerToggleIcon />
  </neo-datepicker-toggle>
  <neo-datepicker-v2 #datePicker [autId]="autId() + '-picker'"></neo-datepicker-v2>
  @if (hint()) {
    <neo-hint>{{ hint() }}</neo-hint>
  }

  <!-- Error messages via reusable component -->
  <cm-field-errors
    [control]="ngControl()?.control || null"
    [label]="label() || 'Date'"
    [customMessages]="errorMessages()"
    [showErrorsWhen]="showErrorsWhen()"
    [hideErrors]="hideErrors()"
    [constraints]="{
      maxlength: null,
      minlength: null,
      min: null,
      max: null
    }"
  />

  <!-- Legacy ng-content projection for backward compatibility -->
  <ng-content />
</neo-form-field>
